import Dialog from '$tablet-app/src/app/components/Dialog';
import DialogHeader from '$tablet-app/src/app/components/Dialog/DialogHeader';
import useBool from '$tablet-app/src/app/utils/state/useBool';
import { AllowSecurityGroups } from '@akin-home/auth/react';
import { CognitoUserGroup } from '@akin-home/aws-cognito';
import { Text } from '@akin-home/text/native';
import { spacing } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { useRoute } from '@react-navigation/native';
import React from 'react';
import { Pressable, ScrollView, StyleSheet, View } from 'react-native';

interface Props {
  parameters?: React.ReactNode;

  context?: React.ReactNode;
}

const security_groups = [
  CognitoUserGroup.ADMIN,
  CognitoUserGroup.DEVELOPER,
  CognitoUserGroup.INTERNAL,
];

export const DeveloperScreenInfo = (props: Props) => {
  return (
    <AllowSecurityGroups security_groups={security_groups}>
      <DeveloperScreenInfoContent {...props} />
    </AllowSecurityGroups>
  );
};

const DeveloperScreenInfoContent = (props: Props) => {
  const { name, params } = useRoute();

  const [dialog_visible, showDialog, hideDialog] = useBool();

  return (
    <>
      <Pressable
        style={({ pressed }) => [
          { opacity: pressed ? 0.5 : 1 },
          styles.infoBubble,
        ]}
        onPress={showDialog}
      >
        <FontAwesomeIcon icon="code" />
      </Pressable>

      <Dialog
        style={styles.dialog}
        visible={dialog_visible}
        onClose={hideDialog}
      >
        <DialogHeader
          center={<Text variant="h3">Developer Screen Info</Text>}
        />
        <ScrollView contentContainerStyle={styles.scrollViewContentContainer}>
          <View>
            <Text weight="semibold">Screen Name</Text>
            <Text>{name}</Text>
          </View>

          <View>
            <Text weight="semibold">Parameters</Text>
            {props.parameters}

            {params ? (
              <>
                <Text>Current Parameters:</Text>
                <Text>{JSON.stringify(params)}</Text>
              </>
            ) : null}
          </View>

          {props.context ? (
            <>
              <Text weight="semibold">Screen Context</Text>
              {props.context}
            </>
          ) : null}
        </ScrollView>
      </Dialog>
    </>
  );
};

const styles = StyleSheet.create({
  dialog: {
    maxWidth: '95%',
    maxHeight: '90%',
  },
  scrollViewContentContainer: {
    padding: spacing[4],
    gap: spacing[3],
  },
  infoBubble: {
    position: 'absolute',

    bottom: 20,
    left: 20,

    height: 30,
    width: 30,
    borderRadius: 30,

    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    backgroundColor: 'white',

    elevation: 1,
  },
});
